import { FormErrors } from 'redux-form'
import i18next from 'i18next'
import { isEmail } from '../../../utils/helpers'

// eslint-disable-next-line import/no-cycle
import { ILoginForm } from './LoginForm'

/**
 * @param {ILoginForm} values
 */
export default (values: any) => {
	const errors: FormErrors<ILoginForm> = {}

	if (!values?.email) {
		errors.email = i18next.t('loc:This field is required')
	} else if (values.email && !isEmail(values.email)) {
		errors.email = i18next.t('loc:Email format is incorrect')
	} else if (values.email?.length > 255) {
		errors.email = i18next.t('loc:Max. number of characters is {{max}}', { max: 255 })
	}

	if (!values?.password) {
		errors.password = i18next.t('loc:This field is required')
	} else if (values.password?.length > 255) {
		errors.password = i18next.t('loc:Max. number of characters is {{max}}', { max: 255 })
	}

	return errors
}
